import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {LinkButtonNew} from '@components/common/base/buttons'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {ColumnId} from '@components/timeline-new/types'
import {EditableTitle} from '@components/upper-panel/editable-title'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {Chevron} from './chevron'
import {TwCell} from './containers'
import {EntityTitle} from './entity-title'
import {NameProps} from './types'

const TwEntityTitle = tw(EntityTitle)`
  text-sm-semibold
  text-primary
  truncate
  flex-1
`

const TwEditableTitle = tw(EditableTitle)`
  text-sm-semibold
  text-primary
  placeholder:font-normal
  placeholder:text-placeholder-new
  h-16
  min-h-16
  max-h-16
  flex-1
`

export const ColumnTitle = observer(
  (props: NameProps & {mirrorPath?: string}) => {
    const {hub, path, expandable, level} = props
    const [, store] = useTimelineNewStore()

    const editing = store.isCellEditing(path, ColumnId.title)

    let padding = level * 16
    if (!expandable) {
      padding += 16
    } else {
      padding -= 8
    }

    padding = Math.max(padding, 0)

    if (hub) {
      return (
        <ColumnTitleHub
          {...props}
          padding={padding}
          editing={editing}
          hub={hub}
        />
      )
    } else {
      if (editing) {
        // todo try not blinking on submit
        return (
          <TwCell style={{paddingLeft: `${padding}px`}} className="truncate">
            <TwEditableTitle
              title=""
              placeholder={Lang.msg.timeline.columnTitlePlaceholder}
              onSubmit={store.addBoardColumn}
            />
          </TwCell>
        )
      } else {
        return (
          <TwCell className="truncate">
            <LinkButtonNew
              icon="IconPlus"
              title={Lang.msg.timeline.addColumnBtn}
              color="secondary"
              className="gap-8 h-full"
              onClick={() =>
                store.startEditing(undefined, path, ColumnId.title)
              }
            />
          </TwCell>
        )
      }
    }
  }
)

interface HubProps extends NameProps {
  hub: Hub
  mirrorPath?: string
  padding: number
  editing: boolean
}

export const ColumnTitleHub = observer((props: HubProps) => {
  const {hub, path, expandable, report, mirror, mirrorPath, type} = props
  const {padding, editing} = props
  const [, store] = useTimelineNewStore()

  useSyncEventUpdateEffect('current', {
    filter: hub.id,
    debounceTime: 50,
    deps: [hub.id]
  })

  return (
    <TwCell style={{paddingLeft: `${padding}px`}} className="truncate">
      {expandable && <Chevron path={path} type={type} />}
      {editing ? (
        <TwEditableTitle
          title={hub.title}
          placeholder={Lang.msg.timeline.taskTitlePlaceholder}
          onSubmit={title => store.editEntityTitle(title, hub.id)}
        />
      ) : (
        <TwEntityTitle
          hubId={hub.id}
          path={path}
          title={hub.title}
          report={report}
          mirror={mirror}
          mirrorPath={mirrorPath}
        />
      )}
    </TwCell>
  )
})
